import { render } from "./WindowMessenger.vue?vue&type=template&id=7041bcba&scoped=true"
import script from "./WindowMessenger.vue?vue&type=script&lang=js"
export * from "./WindowMessenger.vue?vue&type=script&lang=js"

import "./WindowMessenger.vue?vue&type=style&index=0&id=7041bcba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7041bcba"

export default script